export default "__VITE_ASSET__b92fd3ce__"